import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard, notAuthGuard, adminAuthGuard, tokenGuard } from './core/guards/auth.guard';

import { AuthModule } from './features/auth/auth.module';
import { AdminModule } from './features/admin/admin.module';

import { HomeComponent } from './features/main/home/home.component';
import { EnedisComponent } from './features/main/enedis/components/dashboard/enedis-dashboard.component';
import { MainModule } from './features/main/main.module';

import { MainComponent } from './features/main/main.component';

import { AuthComponent } from './features/auth/auth.component';
import { LoginComponent } from './features/auth/login/login.component';
import { ForgotPasswordComponent } from './features/auth/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './features/auth/change-password/change-password.component';
import { SignUpComponent } from './features/auth/signup/signup.component';

import { AdminComponent } from './features/admin/admin.component';
import { AccountComponent } from './features/main/settings/account/account.component';
import { OrganizationComponent } from './features/admin/organization/organization.component';
import { OrganizationDetailComponent } from './features/admin/organization/organization-detail/organization-detail.component';
import { UsersComponent } from './features/admin/users/users.component';
import { OrganizationGeneralComponent } from './features/admin/organization/organization-general/organization-general.component';
import { canDeactivateGuard } from './features/main/settings/account/account.guard';
import { EnedisSearchComponent } from './features/main/enedis/components/search/enedis-search.component';
import { EnedisMeterComponent } from './features/main/enedis/components/meter/enedis-meter.component';
import { enedisAccessRightGuard } from './features/main/enedis/guards/enedis-access-right.guard';
import { EnedisMeterGeneralComponent } from './features/main/enedis/components/meter/general/enedis-meter-general.component';
import { EnedisMeterConsumptionComponent } from './features/main/enedis/components/meter/consumption/enedis-meter-consumption.component';
import { EnedisMeterPowerCurveComponent } from './features/main/enedis/components/meter/power-curve/enedis-meter-power-curve.component';
import { EnedisConsentPageComponent } from './features/main/enedis/components/consent/consent-page/enedis-consent-page.component';
import { EnedisConsentRevokedComponent } from './features/main/enedis/components/consent/consent-revoked/enedis-consent-revoked.component';

import { GrdfComponent } from './features/main/grdf/components/dashboard/grdf-dashboard.component';
import { GrdfMeterGeneralComponent } from './features/main/grdf/components/meter/general/grdf-meter-general.component';
import { grdfAccessRightGuard } from './features/main/grdf/guards/grdf-access-right.guard';
import { GrdfMeterComponent } from './features/main/grdf/components/meter/grdf-meter.component';
import { GrdfMeterConsumptionComponent } from './features/main/grdf/components/meter/consumption/grdf-meter-consumption.component';
import { GrdfConsentPageComponent } from './features/main/grdf/components/consent/consent-page/grdf-consent-page.component';
import { GrdfConsentRevokedComponent } from './features/main/grdf/components/consent/consent-revoked/grdf-consent-revoked.component';

const routes: Routes = [
    {
        path: '',
        component: AuthComponent,
        canActivate: [notAuthGuard],
        children: [
            {
                path: '',
                component: LoginComponent,
            },
        ],
    },
    {
        path: 'forgot-password',
        component: AuthComponent,
        children: [
            {
                path: '',
                component: ForgotPasswordComponent,
            },
        ],
    },
    {
        path: 'change-password',
        component: AuthComponent,
        canActivate: [tokenGuard],
        children: [
            {
                path: '',
                component: ChangePasswordComponent,
            },
        ],
    },
    {
        path: 'signup',
        component: AuthComponent,
        canActivate: [tokenGuard],
        children: [
            {
                path: '',
                component: SignUpComponent,
            },
        ],
    },
    { path: 'enedis-consent', component: EnedisConsentPageComponent },
    { path: 'enedis-consent/revoked', component: EnedisConsentRevokedComponent },
    { path: 'grdf-consent', component: GrdfConsentPageComponent },
    { path: 'grdf-consent/revoked', component: GrdfConsentRevokedComponent },
    {
        path: 'main',
        component: MainComponent,
        canActivate: [authGuard],
        children: [
            { path: '', component: HomeComponent },
            { path: 'enedis', component: EnedisComponent },
            {
                path: 'enedis/:accessRightId',
                canActivate: [enedisAccessRightGuard],
                component: EnedisMeterComponent,
                children: [
                    { path: 'informations', component: EnedisMeterGeneralComponent },
                    { path: 'consumption', component: EnedisMeterConsumptionComponent },
                    { path: 'profil', component: EnedisMeterPowerCurveComponent },
                ],
            },
            { path: 'enedis-search', component: EnedisSearchComponent },
            { path: 'grdf', component: GrdfComponent },
            {
                path: 'grdf/:accessRightId',
                canActivate: [grdfAccessRightGuard],
                component: GrdfMeterComponent,
                children: [
                    { path: 'informations', component: GrdfMeterGeneralComponent },
                    { path: 'consumption', component: GrdfMeterConsumptionComponent },
                    /*
                    { path: 'profil', component: GrdfMeterPowerCurveComponent },
                     */
                ],
            },
            { path: 'account', component: AccountComponent, canDeactivate: [canDeactivateGuard] },
        ],
    },
    {
        path: 'admin',
        component: AdminComponent,
        canActivate: [adminAuthGuard],
        children: [
            { path: 'organization', component: OrganizationComponent },
            {
                path: 'organization-detail/:id',
                component: OrganizationDetailComponent,
                children: [
                    { path: 'general', component: OrganizationGeneralComponent },
                    { path: 'users', component: UsersComponent },
                ],
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes), AuthModule, MainModule, AdminModule],
    exports: [RouterModule],
})
export class AppRoutingModule {}
